var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { P, PCSS, CustomElement, Watch, ViewChild, Utils, PropertyConverters, PacemEventTarget, Components } from '@pacem/pacem-core';
//namespace Pacem.Components.UI {
let PacemCollapseElement = class PacemCollapseElement extends PacemEventTarget {
    constructor() {
        super(...arguments);
        this._resizeHandler = (evt) => {
            this.#state = evt.detail;
            this._toggle();
        };
    }
    #state;
    propertyChangedCallback(name, old, val, first) {
        super.propertyChangedCallback(name, old, val, first);
        if (!first) {
            switch (name) {
                case 'collapse':
                    this._toggle();
                case 'disabled':
                    if (!Utils.isNull(this._resizer)) {
                        this._resizer.disabled = this.disabled || this.collapse;
                    }
                    break;
            }
        }
    }
    viewActivatedCallback() {
        super.viewActivatedCallback();
        const r = this._resizer;
        this.#state = r.currentSize;
        this._toggle();
    }
    _toggle() {
        const div = this, collapse = this.collapse, state = this.#state;
        if (this.disabled || Utils.isNull(div))
            return;
        //
        if (this.horizontal) {
            Utils.addClass(div, PCSS + '-horizontal');
            div.style.height = state && (state.height + 'px') || '';
            div.style.width = collapse ? '0' : (state && state.width + 'px') || '';
        }
        else {
            Utils.removeClass(div, PCSS + '-horizontal');
            div.style.height = collapse ? '0' : (state && state.height + 'px') || '';
        }
    }
};
__decorate([
    Watch({ converter: PropertyConverters.Boolean })
], PacemCollapseElement.prototype, "collapse", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Boolean })
], PacemCollapseElement.prototype, "horizontal", void 0);
__decorate([
    ViewChild(P + '-resize')
], PacemCollapseElement.prototype, "_resizer", void 0);
__decorate([
    ViewChild(`[part=content]`)
], PacemCollapseElement.prototype, "_container", void 0);
PacemCollapseElement = __decorate([
    CustomElement({
        tagName: P + '-collapse', shadow: true,
        template: `<${P}-resize on-${Components.ResizeEventName}=":host._resizeHandler($event)" target="{{ ::_container }}"></${P}-resize><div part="container"><div part="content"><slot></slot></div></div>`
    })
], PacemCollapseElement);
export { PacemCollapseElement };
